import React, {PureComponent} from "react";
import {connect} from "react-redux";
import {formValueSelector} from "redux-form";
import {FILE_STATUS_UPLOADED} from "../../../../../core/constants/FileStatusConstant";
import {DISCOUNT_TYPE_SUM} from "../../../../constants/DiscountTypeConstant";
import PromoCode from "./PromoCode";
import {Trans} from "react-i18next";

class OrderInfo extends PureComponent {

    getTotalPrice = () => {
        let price = this.getBasePrice();

        if (!price) return 0;

        price = price - this.getDiscountPrice();
        price = price + this.getTotalAdditionalPrice();

        return price;
    };

    getTotalFileDuration = () => this.props.fileItems.reduce((duration, file) => {
        if (file.status === FILE_STATUS_UPLOADED) {
            duration += file.duration;
        }
        return duration;
    }, 0);

    getServicePrice = () => {
        const {price, serviceField} = this.props;
        return price[serviceField] || 0;
    };

    convertPrice = price => {
        const {currencyField, currency} = this.props;

        if (!currency[currencyField]) {
            return 0;
        }

        return price * currency[currencyField].rate;
    };

    getBasePriceInUsd = () => {
        const duration = this.getTotalFileDuration();

        if (!duration) return 0;

        return (duration / 60) * this.getServicePrice();
    };

    getBasePrice = () => {
        return this.convertPrice(this.getBasePriceInUsd());
    };

    getDiscountPriceInUsd = () => {
        const price = this.getBasePriceInUsd();
        const {isValid, discount, type} = this.props.coupon;

        let discountPrice = 0;

        if (isValid) {
            if (type === DISCOUNT_TYPE_SUM) {
                discountPrice = discount;
            } else {
                discountPrice = price * (discount / 100);
            }
        }

        return discountPrice;
    };

    getDiscountPrice = () => {
        return this.convertPrice(this.getDiscountPriceInUsd());
    };

    getTotalAdditionalPrice = () => {
        let additionalPrice = 0;

        const additional = this.getAdditional();

        if (additional) {
            if (this.props.rushField) {
                additionalPrice = additionalPrice + parseFloat(additional.rush);
            }
            if (this.props.timestampField) {
                additionalPrice = additionalPrice + parseFloat(additional.timestamp);
            }
            if (this.props.verbatimField) {
                additionalPrice = additionalPrice + parseFloat(additional.verbatim);
            }
        }

        return additionalPrice;
    };

    getAdditional = () => {
        const {currencyField, additional} = this.props;

        return additional[currencyField];
    };

    renderRushPrice = () => {
        if (!this.props.rushField) return null;

        const additional = this.getAdditional();

        return <li>
            <span className="heading">Rush my order:</span>
            <span className="price">{additional.rush}</span>
        </li>
    };

    renderTimestampPrice = () => {
        if (!this.props.timestampField) return null;

        const additional = this.getAdditional();

        return <li>
            <span className="heading">Timestamp my order:</span>
            <span className="price">{additional.timestamp}</span>
        </li>
    };

    renderVerbatimPrice = () => {
        if (!this.props.verbatimField) return null;

        const additional = this.getAdditional();

        return <li>
            <span className="heading">Verbatim my order:</span>
            <span className="price">{additional.verbatim}</span>
        </li>
    };

    render() {
        const discount = this.getDiscountPrice();

        return <div className="box order-box">
            <div className="title-holder inner">
                <span className="title"><Trans>YOUR ORDER</Trans></span>
            </div>
            <ul className="order-info">
                <li>
                    <span className="heading"><Trans>Cost per minute</Trans>:</span>
                    <span className="price">${this.getServicePrice() || '-'}</span>
                </li>
                {this.renderRushPrice()}
                {this.renderTimestampPrice()}
                {this.renderVerbatimPrice()}
            </ul>
            <div className="total-holder">
                <PromoCode discount={discount} />
                <div className="total-frame">
                    <span><Trans>Total cost</Trans>:</span>
                    <span className="price">${this.getTotalPrice().toFixed(2)}</span>
                </div>
            </div>
        </div>
    }
}

const selector = formValueSelector('OrderForm');

export default connect(
    state => ({
        fileItems: state.file.files,
        price: state.dictionary.price,
        additional: state.dictionary.additional,
        currency: state.dictionary.currency,
        coupon: state.order.coupon,
        serviceField: selector(state, 'service'),
        rushField:  selector(state, 'rush'),
        timestampField:  selector(state, 'timestamp'),
        verbatimField:  selector(state, 'verbatim'),
        currencyField: selector(state, 'currency'),
    }),
)(OrderInfo);